import { Checkmark, ReactIcons } from "@kalyzee/kalyzee-ui";
import { Card as KalyzeeCard } from "@kalyzee/kalyzee-ui";

import styles from "./Card.module.css";
import clsx from "clsx";

const IconCard = ({
  icon,
  text,
  selected,
  onClick,
}: {
  icon: React.ReactNode;
  text: string;
  selected?: boolean;
  onClick?: () => void;
}) => {
  return (
    <KalyzeeCard 
      className={clsx({
        [styles.card]: true,
        [styles.iconCard]: true,
        [styles.selected]: selected,
      })}
      nativeProps={{
        onClick,
      }}
      selected={selected}
    >
      {icon}
      <div className={styles.text}>{text}</div>
    </KalyzeeCard>
  );
};

const RadioCard = ({
  text,
  subtext,
  checked,
  disabled,
  onClick,
}: {
  text: string;
  subtext?: string;
  checked?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}) => {
  return (
    <KalyzeeCard 
      className={clsx({
        [styles.card]: true,
        [styles.selected]: checked,
        [styles.disabledBtn]: disabled,
      })}
      nativeProps={{
        onClick,
      }} 
      selected={checked}
    >
      <Checkmark 
        checked={checked}
      />
      <div className={styles.textContainer}>
        <div className={styles.text}>{text}</div>
        {subtext && (
          <div className={styles.subText}>{subtext}</div>
        )}
      </div>
    </KalyzeeCard>
  );
};

export const Card = {
  Icon: IconCard,
  Radio: RadioCard,
};